// extracted by mini-css-extract-plugin
export default {"Main":"Interests_Main__iEOzI","Title":"Interests_Title__v13J6","List":"Interests_List__yUd8O","Edit":"Interests_Edit__yNftu"};